import { apiClient, API_CONFIG } from '../../core';
import type { ApiResponse } from '../../shared';
import { buildQueryString } from '../../shared';
import type {
  LC_GetShiftAssignmentsIn,
  LC_GetShiftAssignmentsListOut,
  ShiftAssignmentListResult,
} from './shiftAssignment.types';
import { mapShiftAssignmentList } from './shiftAssignment.mapper';


export class ShiftAssignmentService {
  /**
   * Get the paginated shift assignment history (ASIS-5656).
   *
   * `dateFrom` / `dateTo` filter by the assignment's START date, and `shiftId` is a
   * numeric id (never the shift name). Company scope and the accessible collaborator
   * universe are resolved on the backend from the JWT and the user's permission level.
   */
  async getShiftAssignments(
    params: LC_GetShiftAssignmentsIn,
    signal?: AbortSignal,
  ): Promise<ApiResponse<ShiftAssignmentListResult>> {
    const queryString = buildQueryString({
      page: params.page,
      pageSize: params.pageSize,
      searchText: params.searchText,
      orderBy: params.orderBy,
      orderDirection: params.orderDirection,
      dateFrom: params.dateFrom,
      dateTo: params.dateTo,
      shiftId: params.shiftId,
      status: params.status,
    });

    const response = await apiClient.get<LC_GetShiftAssignmentsListOut>(
      `${API_CONFIG.ENDPOINTS.SHIFT_ASSIGNMENT.GET_LIST}${queryString}`,
      { signal },
    );

    if (!response.success || !response.data) {
      return { ...response, data: null };
    }

    return { ...response, data: mapShiftAssignmentList(response.data) };
  }
}

export const shiftAssignmentService = new ShiftAssignmentService();
